<script>
  import { TableCell, TableRow } from "carbon-components-svelte";
  import FolderIcon from "../../../routes/app/processmodeler-frontend/components/svg/FolderIcon.svelte";
  import ActiveFolderIcon from "../../../routes/app/processmodeler-frontend/components/svg/ActiveFolderIcon.svelte";
  import ProcessIcon from "../../../routes/app/processmodeler-frontend/components/svg/ProcessIcon.svelte";
  import ChevronIcon from "../../../routes/app/processmodeler-frontend/components/svg/ChevronIcon.svelte";
  import IconComponent from "../../../../src/routes/app/settings/svg/index.svelte";
  export let row = {
    children: [],
    name: "",
    id: -1,
    access_right: { team_ids: [], user_ids: [] },
  };
  export let parentRow = [];
  export let headers = [];
  export let margin = 1;
  export let dataObject;
  export let processInfo;
  let isExpanded = false;

  $: getClassName = (rowObj, row) => {
    if (rowObj.key === "name") {
      if (row.type === "folder" || processInfo) {
        if (margin === 1 && isExpanded) {
          return "bold-pointer cursor-pointer";
        } else if (rowObj.type === "CallActivity") {
          return "dullRow";
        } else {
          return "cursor-pointer";
        }
      }
    }
  };

  const getAccessList = (list, data) => {
    const obj = list.map((d) => {
      return data[d];
    });
    return obj;
  };

  const isActionVisible = (action) =>
    !(
      (margin === 1 && action.key === "move") ||
      (row.type === "process" && action.key === "newElement")
    );
  //   const display = children ? ids.includes(id) ? 'flex' : 'none': 'initial';
</script>

<TableRow id={row.id} class={row.type === "CallActivity" && "dullRow"}>
  {#each headers as rowObject}
    {#if rowObject.type === "actions"}
      <TableCell class="actions-column">
        <div class="actions-cell">
          {#each rowObject.actions || [] as action}
            {#if isActionVisible(action)}
              <button
                title={action.key}
                on:click={() => action.action?.(row, action.key, parentRow)}
              >
                <IconComponent icon={action.icon || "arrow"} />
              </button>
            {/if}
          {/each}
        </div>
      </TableCell>
    {:else if rowObject.type === "action"}
      {#if (margin === 1 && rowObject.key === "move") || (row.type == "process" && rowObject.key === "newElement")}
        <TableCell />
      {:else}
        <TableCell
          ><button
            on:click={() => {
              if (rowObject?.action)
                rowObject?.action(row, rowObject.key, parentRow);
            }}><IconComponent icon={rowObject.icon || "arrow"} /></button
          ></TableCell
        >
      {/if}
    {:else if rowObject.key === "access_right"}
      <TableCell
        >{getAccessList(
          row["access_right"]?.team_ids.concat(row["access_right"]?.user_ids),
          dataObject
        )}</TableCell
      >
    {:else}
      <TableCell
        on:click={() => {
          if (rowObject.key === "name") isExpanded = !isExpanded;
        }}
        class={getClassName(rowObject, row)}
      >
        <div class="cell-container">
          {#if rowObject.key === "name"}<div
              style="width: {margin}rem;height: 1px;background:rgba(40, 40, 40, 0.25)"
            />
            {#if row.type === "folder"}
              {#if isExpanded}
                <ActiveFolderIcon />
              {:else}
                <FolderIcon />
              {/if}
            {:else}
              <div class={isExpanded ? "reverseIcon" : ""}>
                <ChevronIcon />
              </div>
            {/if}
            {#if row.type === "process"}
              <ProcessIcon />
            {/if}
          {/if}
          {row[rowObject?.key]}
        </div></TableCell
      >
    {/if}
  {/each}
</TableRow>
{#if isExpanded && row.children.length}
  {#each row.children as child}
    <svelte:self
      parentRow={row}
      row={child}
      margin={margin + 1}
      {headers}
      children={true}
      {dataObject}
      {processInfo}
    />
  {/each}
{/if}

<style>
  .cell-container {
    display: flex;
    align-items: center;
    gap: 3px;
  }
  .actions-cell {
    display: flex;
    align-items: center;
    gap: 0.35rem;
  }
  button {
    background: var(--pax-black);
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: grid;
    place-items: center;
  }
  :global(.cursor-pointer) {
    cursor: pointer;
  }
  :global(.bold-pointer) {
    cursor: pointer;
    font-weight: 700;
    font-size: 14px;
  }
  .reverseIcon {
    transform: rotate(180deg);
  }
  :global(.dullRow) {
    opacity: 0.5;
    cursor: not-allowed;
  }
  :global(.dullRow td) {
    cursor: not-allowed;
  }
</style>
